import CircleCheckmarkIcon from "assets/icons/CircleCheckmarkIcon";
import classnames from "classnames";
import { PaymentMethodPickerItemType } from "types/components/PaymentMethodPicker";
import { renderLogo } from "utils/renderLogo";
import styles from "./styles.module.scss";
import { EnumPaymentProvider } from "types/api/api";

interface PaymentMethodPickerItemProps extends PaymentMethodPickerItemType {
  active: boolean;
  setActiveItemId: (id: EnumPaymentProvider) => void;
}

const PaymentMethodPickerItem = ({
  id,
  active,
  setActiveItemId,
  text,
  disabled
}: PaymentMethodPickerItemProps) => {
  return (
    <div
      role="button"
      data-testid="payment-method-picker-item"
      className={classnames(styles.paymentMethodItemWrapper, {
        [styles.paymentMethodItemWrapperActive]: active && !disabled,
        [styles.paymentMethodItemWrapperDisable]: disabled
      })}
      onClick={() => {
        if (!disabled && id) {
          setActiveItemId(id);
        }
      }}
    >
      <div className={classnames(styles.paymentMethodItemCard)}>
        <div
          className={styles.paymentMethodItemImage}
          style={{ backgroundImage: `url(${renderLogo(id)})` }}
        ></div>
        {!disabled && <CircleCheckmarkIcon className={styles.checkmarkIcon} />}
      </div>

      <div className={classnames(styles.paymentMethodItemText, "text-truncate")}>{text}</div>
    </div>
  );
};

export default PaymentMethodPickerItem;
